<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="mt-5 text-dark" style="text-align: center; width: 100%;">
                <p>
                    RevIoTBox is a <a href="https://www.corporate-hangar.com/" style="color: blue;">Corporate Hangar</a>
                    project, check our
                    <a href="https://www.corporate-hangar.com/pages/privacy/" style="color: blue;">Privacy Policy</a>
                </p>
            </div>
        </div>
    </div>
</footer>
